<app-menu>
  <div class="cap-page">
    <div class="cap-toolbar">
      <div class="cap-toolbar__left">
        <div class="cap-title">
          <div class="cap-title__h1">Contact Access Profiles</div>
          <div class="cap-title__sub">Manage dynamic grid access profiles (contacts)</div>
        </div>
      </div>

      <div class="cap-toolbar__right">
        <button class="cap-btn" (click)="addFieldRow()" [disabled]="!selectedProfile">
          + Field
        </button>

        <button class="cap-btn cap-btn--primary" (click)="saveProfile()" [disabled]="!selectedProfile || saving">
          Save
        </button>

        <button class="cap-btn" (click)="refreshData()" [disabled]="loading">
          Refresh
        </button>
      </div>
    </div>

    <div class="cap-shell">
      <aside class="cap-pane cap-pane--left">
        <div class="cap-pane__header">
          <div class="cap-pane__header-title">Profiles</div>

          <div class="cap-pane__header-actions">
            <button class="cap-btn cap-btn--tiny" (click)="createNewProfileStub()" [disabled]="saving">
              + New
            </button>
          </div>
        </div>

        <div class="cap-pane__body cap-list">
          <div class="cap-empty" *ngIf="profiles.length === 0">
            No profiles loaded yet.
          </div>

          <div
            class="cap-card"
            *ngFor="let p of profiles"
            [class.cap-card--active]="selectedProfile?.contact_access_profile_uuid === p.contact_access_profile_uuid"
            (click)="selectProfile(p)"
          >
            <div class="cap-card__top">
              <div class="cap-card__name">{{ p.profile_name }}</div>
              <div class="cap-card__badges">
                <span class="cap-badge" [class.cap-badge--on]="p.active">active</span>
                <span class="cap-badge" [class.cap-badge--on]="p.is_default">default</span>
              </div>
            </div>

            <div class="cap-card__meta">
              <span class="cap-meta">{{ p.entity_target }}</span>
              <span class="cap-dot">•</span>
              <span class="cap-meta">{{ p.base_view }}</span>
              <span class="cap-dot">•</span>
              <span class="cap-meta">type: {{ p.profile_type ?? '—' }}</span>
            </div>

            <div class="cap-card__meta" *ngIf="p.contact_uuid">
              <span class="cap-meta cap-meta--mono">{{ p.contact_uuid }}</span>
            </div>
          </div>
        </div>
      </aside>

      <main class="cap-pane cap-pane--right">
        <div class="cap-pane__header">
          <div class="cap-pane__header-title">Editor</div>
          <div class="cap-pane__header-actions">
            <div class="cap-msg cap-msg--err" *ngIf="errorMessage">{{ errorMessage }}</div>
            <div class="cap-msg cap-msg--ok" *ngIf="infoMessage">{{ infoMessage }}</div>
          </div>
        </div>

        <div class="cap-pane__body" *ngIf="selectedProfile; else capNoSelection" style="display: flex; flex-direction: column;">
          <div class="cap-block">
            <div class="cap-block__title">Profile Settings</div>

            <form [formGroup]="profileForm" class="cap-form">
              <div class="cap-form__row">
                <label>Profile Name</label>
                <input type="text" class="cap-input" formControlName="profile_name" />
              </div>

              <div class="cap-form__row">
                <label>Entity Target</label>
                <input type="text" class="cap-input" formControlName="entity_target" />
              </div>

              <div class="cap-form__row">
                <label>Base View</label>
                <input type="text" class="cap-input" formControlName="base_view" />
              </div>

              <div class="cap-form__row">
                <label>Profile Type</label>
                <input type="number" class="cap-input" min="1" max="4" formControlName="profile_type" />
              </div>

              <div class="cap-form__row">
                <label>Contact UUID</label>
                <input type="text" class="cap-input" formControlName="contact_uuid" placeholder="(optional)" />
              </div>

              <div class="cap-form__row cap-form__row--inline">
                <label class="cap-check">
                  <input type="checkbox" formControlName="active" />
                  Active
                </label>

                <label class="cap-check">
                  <input type="checkbox" formControlName="is_default" />
                  Default
                </label>
              </div>
            </form>
          </div>

          <div class="cap-block" style="flex: 1; display: flex; flex-direction: column; min-height: 0;">
            <div class="cap-block__title cap-block__title--row" style="flex-shrink: 0;">
              <span>Field Config</span>
              <div class="cap-block__title-actions">
                <button class="cap-btn cap-btn--tiny" (click)="addFieldRow()" [disabled]="saving">+ Field</button>
              </div>
            </div>

            <div style="flex: 1; min-height: 0;">
              <ag-grid-angular
                class="ag-theme-ulaap cap-grid"
                style="height: 100%; width: 100%;"
                [rowData]="fieldRowData"
                [columnDefs]="fieldColumnDefs"
                [defaultColDef]="{ resizable: true, sortable: true, filter: true }"
                [animateRows]="true"
                [rowDragManaged]="true"
                [suppressMoveWhenRowDragging]="false"
                [rowHeight]="40"
                (gridReady)="onFieldGridReady($any($event))"
                (rowDragEnd)="onFieldRowDragEnd($any($event))"
              >
              </ag-grid-angular>
            </div>
          </div>
        </div>

        <ng-template #capNoSelection>
          <div class="cap-empty-big">
            <div class="cap-empty-big__h1">Pick a profile on the left.</div>
            <div class="cap-empty-big__sub">
              This editor will let you create and manage contact access profiles.
            </div>
          </div>
        </ng-template>
      </main>
    </div>
  </div>
</app-menu>

<div class="cap-modal-backdrop" *ngIf="joinBuilder.isOpen">
  <div class="cap-modal">
    <div class="cap-modal__header">
      <div class="cap-title__h1">Configure Relational Join</div>
      <button class="cap-btn-close" (click)="closeJoinBuilder()">&#x2715;</button>
    </div>

    <div class="cap-modal__body">
      <div class="cap-msg cap-msg--ok" style="margin-bottom: 15px;">
        Building join for grid column: <strong>{{ joinBuilder.field?.db_field || 'New Column' }}</strong>
      </div>

      <div class="cap-join-step" *ngFor="let step of joinBuilder.steps; let i = index">
        <div class="cap-join-step__header">
          <strong>Hop {{ i + 1 }}</strong>
          <button class="cap-btn cap-btn--tiny" (click)="removeJoinStep(i)">Remove</button>
        </div>

        <div class="cap-form__row cap-form__row--inline">
          <div>
            <label class="cap-modal-label">Join Strategy</label>
            <select class="cap-select" [(ngModel)]="step.type">
              <option value="LEFT JOIN">Standard Join</option>
              <option value="LATERAL LATEST">Latest Record (Lateral)</option>
            </select>
          </div>
          <div>
            <label class="cap-modal-label">Target Table</label>
            <input type="text" class="cap-input" [(ngModel)]="step.target_table" [attr.list]="'tt-list-' + i" placeholder="Table name..." />
            <datalist [id]="'tt-list-' + i">
              <option *ngFor="let t of getDynamicTables()" [value]="t"></option>
            </datalist>
          </div>
          <div>
            <label class="cap-modal-label">Table Alias (Optional)</label>
            <input type="text" class="cap-input" [(ngModel)]="step.alias" placeholder="e.g. ta" />
          </div>
        </div>

        <div class="cap-form__row cap-form__row--inline" style="margin-top: 15px;">
          <div style="flex: 1;">
            <label class="cap-modal-label">Source Match</label>
            <div style="display: flex; gap: 8px;">
              <input type="text" class="cap-input" style="flex: 1;" [(ngModel)]="step.source_table" [attr.list]="'st-list-' + i" placeholder="Source table..." />
              <datalist [id]="'st-list-' + i">
                <option *ngFor="let prev of getPreviousTables(i)" [value]="prev"></option>
              </datalist>

              <input type="text" class="cap-input" style="flex: 1;" [(ngModel)]="step.source_column" [attr.list]="'sc-list-' + i" placeholder="Source column..." />
              <datalist [id]="'sc-list-' + i">
                <option *ngFor="let col of getDynamicColumns(step.source_table)" [value]="col"></option>
              </datalist>
            </div>
          </div>
          <div style="flex: 1;">
            <label class="cap-modal-label">Target Match</label>
            <input type="text" class="cap-input" style="width: 100%;" [(ngModel)]="step.target_column" [attr.list]="'tc-list-' + i" placeholder="Target column..." />
            <datalist [id]="'tc-list-' + i">
              <option *ngFor="let col of getDynamicColumns(step.target_table)" [value]="col"></option>
            </datalist>
          </div>
        </div>

        <div class="cap-form__row" *ngIf="step.type === 'LATERAL LATEST'" style="margin-top: 15px;">
          <label class="cap-modal-label">Sort By (Newest First)</label>
          <input type="text" class="cap-input" [(ngModel)]="step.sort_column" [attr.list]="'sort-list-' + i" placeholder="e.g. created" />
          <datalist [id]="'sort-list-' + i">
            <option *ngFor="let col of getDynamicColumns(step.target_table)" [value]="col"></option>
          </datalist>
        </div>
      </div>

      <button class="cap-btn" (click)="addJoinStep()">+ Add Hop</button>

      <div class="cap-sql-preview">
        <strong>Compiled Database SQL:</strong>
        <code>{{ previewCompiledSql() }}</code>
      </div>
    </div>

    <div class="cap-modal__footer">
      <button class="cap-btn" (click)="closeJoinBuilder()">Cancel</button>
      <button class="cap-btn cap-btn--primary" (click)="saveJoinBuilder()">Save Join Configuration</button>
    </div>
  </div>
</div>